import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import { isAuthenticated, isTokenLikelyExpired, clearAuthData } from './utils/auth';
import './App.css';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Check if token is expired
  if (isAuthenticated() && isTokenLikelyExpired()) {
    clearAuthData();
    return <Navigate to="/login" />;
  }
  
  return isAuthenticated() ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  // Check for expired tokens on app load
  useEffect(() => {
    if (isAuthenticated() && isTokenLikelyExpired()) {
      console.log('Token expired on app load, clearing auth data');
      clearAuthData();
    }
  }, []);
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route 
            path="/login" 
            element={isAuthenticated() ? <Navigate to="/dashboard" /> : <LoginPage />} 
          />
          
          {/* Protected Routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Default redirect */}
          <Route 
            path="/" 
            element={<Navigate to={isAuthenticated() ? "/dashboard" : "/login"} />} 
          />
          
          {/* Catch all route */}
          <Route 
            path="*" 
            element={<Navigate to={isAuthenticated() ? "/dashboard" : "/login"} />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
